import * as PropTypes from 'prop-types';
import * as React from 'react';

const USD = 'USD';

class PriceDisplay extends React.Component {
  shouldShowFree() {
    return this.props.showFree && this.props.price.amount_cents === 0;
  }

  currencyDisplay() {
    if (this.props.showCurrency && this.props.price.currency !== USD) {
      return <span className="price-currency">{this.props.price.currency}</span>;
    }
    return null;
  }

  render() {
    if (!this.props.price) { return false; }
    if (this.shouldShowFree()) { return <span>{I18n.t('js.free')}</span>; }

    return (
      <span className="ws-nowrap">
        {this.props.price.display}
        {this.currencyDisplay()}
      </span>
    );
  }
}

PriceDisplay.defaultProps = {
  showFree: false,
  showCurrency: true,
};

PriceDisplay.propTypes = {
  price: PropTypes.object,
  showFree: PropTypes.bool,
  showCurrency: PropTypes.bool,
};


export default PriceDisplay;



// WEBPACK FOOTER //
// ./javascripts/components/shared/price_display.jsx